export default __webpack_public_path__ + "static/image-54-be9a8f3b7e6dd5f49b3e1dcd3d8e5576.jpg";